var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMemberInsuranceOk(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M512,0C229.22,0,0,229.25,0,512s229.22,512,512,512,512-229.22,512-512S794.75,0,512,0ZM804.61,357.02l-320,384c-12.13,14.56-30.08,23.01-49.02,23.07h-.13c-18.91,0-36.85-8.38-48.99-22.88l-167.52-199.49c-23.21-26.65-20.43-67.08,6.23-90.3s67.08-20.42,90.3,6.23c.49.56.96,1.12,1.43,1.7l118.34,140.96,271.04-325.25c23.43-26.49,63.9-28.96,90.39-5.53,25.39,22.46,28.87,60.81,7.95,87.48h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberInsuranceOk);
export default __webpack_public_path__ + "static/media/member-insurance-ok.7e1f6d31e355acdda9623238c9b99c4d.svg";
export { ForwardRef as ReactComponent };